<template>
    <div>

        <v-menu
            ref="menu"
            v-model="menuOpen"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
        >
            <template v-slot:activator="{ on }">
                <v-text-field
                    v-model="dateItem.date"
                    :label="$t('instance.data_model.form_editor.fields_types.date_field.date_label')"
                    :rules="dateRule"
                    v-on="on"
                ></v-text-field>
            </template>
            <v-date-picker
                v-model="dateItem.date"
                scrollable
                @input="menuOpen = false"
            >
            </v-date-picker>
        </v-menu>
        <div v-if="datatype === 'datetime'" >
            <v-text-field
                ref="time"
                v-model="dateItem.time"
                type="text"
                :label="$t('instance.data_model.form_editor.fields_types.date_field.time_label')"
                :rules="timeRule"
            >
            </v-text-field>
        </div>
    </div>
</template>

<script>
import FieldMixin from './field-mixin.vue';
import moment from 'moment';
export default {
    mixins: [FieldMixin],
    components: {
    },

    props: {

    },

    data (){
        return {
            menuOpen: false,
            dateItem: {
                date: '',
                time: '',
            },
            hours: '',
            minutes: '',
            seconds: '',
        };
    },

    computed: {
        rulesList (){
            return {
                date: [],
                datetime: [],
            };
        },
        timeRule (){
            if(this.formActive) {
                return [
                    v => v === '' || /\d{2}\:\d{2}\:\d{2}/.test(v) || this.$t('instance.data_model.form_editor.fields_types.date_field.time_rule.main'),
                    v => {
                        if(this.property.attributes.allow_empty ){
                            return true;
                        }
                        if(this.dateItem.date === ''){
                            return this.$t('instance.data_model.form_editor.fields_types.date_field.time_rule.no_date');
                        }
                        if(v === ''){
                            return true;
                        }
                        let hours, minutes,seconds;
                        [hours, minutes, seconds] = v.split(':');
                        if(hours < 0 || hours > 23){
                            return this.$t('instance.data_model.form_editor.fields_types.date_field.time_rule.hours');
                        }else if(minutes < 0 || minutes > 59){
                            return this.$t('instance.data_model.form_editor.fields_types.date_field.time_rule.minutes');
                        }else if(seconds < 0 || seconds > 59){
                            return this.$t('instance.data_model.form_editor.fields_types.date_field.time_rule.seconds');
                        }
                        return true;
                    }
                ];
            }

        },

        dateRule (){
            if(this.formActive) {
                return [
                    v => {
                        if(
                           this.datatype === 'datetime' &&
                           this.dateItem.time !== '' &&
                           v === ''){
                            return this.$t('instance.data_model.form_editor.fields_types.date_field.date_rule');
                        }
                        return true;
                    }
                ];
            }
        },

    },
    watch: {
        value: {
            handler(val) {
                let date = new Date(val);
                if(!(date instanceof Date) && isNaN(date)){
                    this.valueCopy = '';
                }
            },
            immediate: true,
        },

        dateItem:{
            handler (val){
                let date = moment(val.date);
                if(this.datatype === 'datetime'){
                    let hours, minutes,seconds;
                    [hours, minutes, seconds] = val.time.split(':');
                    date.hour(hours);
                    date.minute(minutes);
                    date.second(seconds);
                }
                this.valueCopy = date.toISOString();
                this.emitValue();
            },
            deep: true,
        },



    },

    mounted (){
        let date = new Date(this.value);
        if(date instanceof Date && !isNaN(date)){
            this.dateItem.date = moment(this.value).format('YYYY-MM-DD');
            this.dateItem.time = moment(this.value).format('HH:mm:ss');
        }
    },

    methods: {
        // updateLocale() {
        //     console.log('update')
        //     this.formActive = false;
        //     this.$nextTick(() => {
        //         console.log('tick')
        //         this.formActive = true;
        //     });
        // },
        // ruleByLocale(){
        //     if(this.currentLocale === 'fr'){

        //     }
        // }
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/page/Instance/DataModel/FormEditor/FieldsTypes/date-field.vue